import axios from "axios";
const postsUrlVE = "https://voltemosaoevangelho.com/blog/wp-json/wp/v2/posts";
const postsUrlMF = "https://ministeriofiel.com.br/wp-json/wp/v2/artigos";
const queryOptions = {
  per_page: 7,
  page: 1,
  _embed: true,
  _embedded: true,
};

export default {
  listVE(context) {
    return new Promise((resolve, reject) => {
      axios
        .get(postsUrlVE, { params: queryOptions })
        .then((response) => {
          context.commit("setArticlesVE", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  listMF(context) {
    return new Promise((resolve, reject) => {
      axios
        .get(postsUrlMF, { params: queryOptions })
        .then((response) => {
          context.commit("setArticlesMF", response.data);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
